import React from "react";
import "./Review.css"
const ReviewsHeading = () => {
  return (
    <div className="reviewsHeading">
      <h2>What Our Customers Say</h2>
      <div className="reviewUnderline"></div>
    </div>
  );
};

export default ReviewsHeading;
